// src/config/s3Config.js
// S3 Configuration Template

// Development Configuration
export const S3_CONFIG_DEV = {
  bucketName: process.env.REACT_APP_S3_BUCKET_NAME || "your-dev-bucket",
  region: process.env.REACT_APP_AWS_REGION || "us-east-1",
  accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID || "your-access-key",
  secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY || "your-secret-key",
  // sessionToken: process.env.REACT_APP_AWS_SESSION_TOKEN || "helo"
};

// Production Configuration (use environment variables)
export const S3_CONFIG_PROD = {
  bucketName: process.env.REACT_APP_S3_BUCKET_NAME,
  region: process.env.REACT_APP_AWS_REGION,
  accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
  secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
  // sessionToken: process.env.REACT_APP_AWS_SESSION_TOKEN || "helo"
};

// Get configuration based on environment
export const getS3Config = () => {
  const isDevelopment = process.env.NODE_ENV === 'development';
  console.log(isDevelopment ? S3_CONFIG_DEV : S3_CONFIG_PROD, 'isDevelopment ? S3_CONFIG_DEV : S3_CONFIG_PROD')
  return isDevelopment ? S3_CONFIG_DEV : S3_CONFIG_PROD;
};

// Validate configuration
export const validateS3Config = (config) => {
  const required = ['bucketName', 'region', 'accessKeyId', 'secretAccessKey'];
  const missing = required.filter(key => !config[key]);
  if (missing.length > 0) {
    throw new Error(`Missing S3 configuration: ${missing.join(', ')}`);
  }
  return true;
};

// File upload constraints
export const UPLOAD_CONSTRAINTS = {
  maxFileSize: 10 * 1024 * 1024, // 10MB
  allowedTypes: [
    'image/jpeg', 'image/png', 'image/gif', 'image/webp',
    'application/pdf', 'text/plain', 'text/csv',
    'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/zip', 'application/x-rar-compressed',
    'video/mp4', 'audio/mpeg', 'audio/wav'
  ],
  allowedExtensions: [
    'jpg', 'jpeg', 'png', 'gif', 'webp',
    'pdf', 'txt', 'csv', 'doc', 'docx', 'xls', 'xlsx',
    'zip', 'rar', 'mp4', 'mp3', 'wav'
  ]
};

// S3 URL patterns
export const S3_URL_PATTERNS = {
  standard: (bucketName, region, key) =>
    `https://${bucketName}.s3.${region}.amazonaws.com/${key}`,
  pathStyle: (bucketName, region, key) =>
    `https://s3.${region}.amazonaws.com/${bucketName}/${key}`,
  cloudfront: (distributionDomain, key) =>
    `https://${distributionDomain}/${key}`
};

// ✅ Named object for default export
const s3Config = {
  getS3Config,
  validateS3Config,
  UPLOAD_CONSTRAINTS,
  S3_URL_PATTERNS
};

export default s3Config;